import axios from 'axios'
import { Modal, Space, Typography, Upload } from 'antd'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { notify } from 'reapop'

import Button from 'components/Button'
import Icon from 'components/Icon'
import { ICONS } from 'utils/constants'
import { bulkCreatePromocodes, getPromocodeBulkSample } from 'api/promocodes'

const PromocodeBulkUploadModal = ({ open, onClose }) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  const { data: bulkSample, isFetching: isBulkSampleFetching } = useQuery(
    ['promocodesBulkSample'],
    async () => await getPromocodeBulkSample(),
    { enabled: !!open },
  )

  const bulkCreateMutation = useMutation(bulkCreatePromocodes, {
    onSuccess: (res) => {
      queryClient.invalidateQueries(['promocodesTable'])
      dispatch(
        notify({
          title: `Bulk upload done: ${res?.successCount || 0} success, ${res?.failureCount || 0} failed`,
          status: res?.failureCount ? 'warning' : 'success',
          dismissAfter: 5000,
        }),
      )
    },
    onError: (error) =>
      axios.isAxiosError(error) &&
      dispatch(notify({ title: error.message, status: 'error', dismissAfter: 4000 })),
  })

  const downloadSample = () => {
    const csv = bulkSample?.csv
    if (!csv) return
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'promocode-bulk-sample.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  const handleBeforeUpload = async (file) => {
    try {
      await bulkCreateMutation.mutateAsync({ file })
      onClose?.()
    } catch (e) {
      dispatch(
        notify({
          title: e?.message || 'Failed to upload CSV',
          status: 'error',
          dismissAfter: 5000,
        }),
      )
    }
    return Upload.LIST_IGNORE
  }

  return (
    <Modal
      title="Bulk Upload Promo Codes (CSV)"
      visible={!!open}
      onCancel={() => (bulkCreateMutation.isLoading ? null : onClose?.())}
      footer={null}
      destroyOnClose
    >
      <Space direction="vertical" style={{ width: '100%' }} size={12}>
        <Space>
          <Button type="default" onClick={downloadSample} disabled={isBulkSampleFetching}>
            Download Sample CSV
          </Button>
          <Typography.Text type="secondary">
            Customer = customer code OR phone number. Select Customer = ALL_CUSTOMERS / NEW_CUSTOMER / EXISTING_CUSTOMER / SPECIFIC_CUSTOMER.
          </Typography.Text>
        </Space>

        <Upload
          accept=".csv,text/csv"
          showUploadList={false}
          beforeUpload={handleBeforeUpload}
          disabled={bulkCreateMutation.isLoading}
        >
          <Button type="primary" disabled={bulkCreateMutation.isLoading}>
            <Icon icon={ICONS.UPLOAD} className="btn-icon-suffix" />
            <span className="btn-text">Upload CSV</span>
          </Button>
        </Upload>

        {bulkCreateMutation.data ? (
          <Typography.Text>
            Result: <b>{bulkCreateMutation.data.successCount}</b> success,{' '}
            <b>{bulkCreateMutation.data.failureCount}</b> failed
          </Typography.Text>
        ) : null}
      </Space>
    </Modal>
  )
}

export default PromocodeBulkUploadModal


